export default "__VITE_ASSET__a85347e0__"